module.exports = __webpack_public_path__ + "media/images/emblems/Wilderswil-coat_of_arms-10882c8ccc63c8ca951afd1800af4348.svg";